import React, { FC } from 'react';
import { variants } from 'app/options';
import locales from 'app/config/locales.json';
import { DebugDropdown } from 'app/components/debug/DebugDropdown';
import { DebugSwitch } from 'app/components/debug/DebugSwitch';
import * as styles from './Debug.scss';
import { SearchMaskMountOptions } from '@webc/meeseeks-ui-sdk';
import { useAppDispatch, useAppSelector } from 'app/hooks/appHooks';
import { optionsSelector } from 'app/store/selectors';
import { updateOptions } from 'app/store/thunk/general/updateSearchOptionsThunk';

const getLanguageObject = (locale: string) => ({
  value: locale,
  label: locale,
});

export const Debug: FC = () => {
  const dispatch = useAppDispatch();
  const options = useAppSelector(optionsSelector);

  return (
    <div className={styles.debugWrapper}>
      <div className={styles.debug}>
        <div className={`search-mask__language-chooser ${styles.debugSection}`}>
          <span className={styles.debugSectionLabel}>Locale</span>
          <DebugDropdown
            selected={getLanguageObject(options.locale)}
            options={locales.map(getLanguageObject)}
            onChange={(x: { value: string; label: string }) => {
              dispatch(
                updateOptions({
                  locale: x.value,
                } as SearchMaskMountOptions),
              );
            }}
          />
        </div>
        <div className={styles.debugSection}>
          <span className={`search-mask__variant-chooser ${styles.debugSectionLabel}`}>Layout</span>

          <DebugSwitch
            options={variants}
            selected={options.variant}
            onChange={(variant) =>
              dispatch(
                updateOptions({
                  variant: variant.value,
                } as SearchMaskMountOptions),
              )
            }
          />
        </div>
        <div className={styles.debugSection}>
          <span className={styles.debugSectionLabel}>FlixTrain</span>

          <DebugSwitch
            options={[
              {
                value: 'off',
                label: 'Off',
              },
              {
                value: 'on',
                label: 'On',
              },
            ]}
            selected={options.flixTrain ? 'on' : 'off'}
            onChange={(action) =>
              dispatch(
                updateOptions({
                  flixTrain: action.value === 'on',
                } as SearchMaskMountOptions),
              )
            }
          />
        </div>
        <div className={styles.debugSection}>
          <span className={styles.debugSectionLabel}>Theme</span>

          <DebugSwitch
            options={[
              {
                value: 'flix',
                label: 'flix',
              },
              {
                value: 'kamil',
                label: 'kk',
              },
              {
                value: 'neptune',
                label: 'gh',
              },
            ]}
            selected={options.theme}
            onChange={(action) =>
              dispatch(
                updateOptions({
                  theme: action.value,
                } as SearchMaskMountOptions),
              )
            }
          />
        </div>
      </div>
    </div>
  );
};
